// @ts-nocheck
import { saveAs } from "file-saver";
import Excel from "exceljs";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import { useAuthStore } from "src/components/main/authStore";
import {
    mimeTypeMap, 
    getDatefromWeekNum, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filteredForms, 
    week, 
}){
    const user = useAuthStore(state => state.user);
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const handleExport = () => {
        setShowLoader(true);
        const headerRowNum = 2/*#*/;
        const infoCol = [
            "Compnay", "Employee", "Lan ID", "Cell Phone", 
            "Function", "Residence", "Division Assigned",
            "On-Call availability"
        ];
        const availabilityColNum = 8/*#*/;
        const infoColNum = infoCol.length;
        const totalColNum = infoColNum + 7;
        const pos = e => {
            switch(e){
                case "locator":
                    return "L&M";
                case "qew":
                    return "QEW";
                case "standby":
                    return "StandBy";
                default:
                    return "";
            }
        }
        //----------------------------------------------
        const data1 = filteredForms.filter(d => d.outside === "locator");
        const data2 = filteredForms.filter(d => d.outside === "standby");
        const data3 = filteredForms.filter(d => d.outside === "qew");
        const mainData = [data1, data2, data3].filter(arr => arr.length).reduce((a, b) => [...a, {}, {}, ...b]);
        if(!data1.length && !data2.length && !data3.length){
            window.alert("Nobody submitted.");
            return;
        }
        const workbook = new Excel.Workbook();                            
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet(
            `${getDatefromWeekNum(week, 4).slice(5)} to ${getDatefromWeekNum(week, 10).slice(5)}`
            , {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 18;
        //--------------------------------------------------
        worksheet.getCell(1, 1).value = "Locate and Mark:  After-hour Emergency Call Out Availability List";
        worksheet.getCell(1, 1).style = {
            font: {size: 24, name: "Arial"}, 
            fill: {
                type: "pattern", 
                pattern:"solid", 
                fgColor:{argb:"A8D08D"}
            }, 
            alignment: {
                vertical: "middle", 
                horizontal: "center"
            },
            border: {
                top: {style: "thin"},
                left: {style: "thin"},
                bottom: {style: "thin"},
                right: {style: "thin"}
            }
        };
        worksheet.mergeCells(1, 1, 1, totalColNum);
        worksheet.getRow(1).height = 37.5;
        //--------------------------------------------------
        worksheet.getRow(2).values = [
            ...infoCol,
            `Friday ${getDatefromWeekNum(week, 4).slice(5)}`, 
            `Saturday ${getDatefromWeekNum(week, 5).slice(5)}`,
            `Sunday ${getDatefromWeekNum(week, 6).slice(5)}`,
            `Monday ${getDatefromWeekNum(week, 7).slice(5)}`, 
            `Tuesday ${getDatefromWeekNum(week, 8).slice(5)}`,
            `Wednesday ${getDatefromWeekNum(week, 9).slice(5)}`,
            `Thursday ${getDatefromWeekNum(week, 10).slice(5)}`
        ]
        for(let i = 1; i <= totalColNum; i++){
            worksheet.getCell(2, i).style = {
                font: {size: 18},
                fill: {
                    type: "pattern", 
                    pattern:"solid", 
                    fgColor:{argb: "00B0F0"}
                },
                alignment: {
                    vertical: "middle", 
                    horizontal: "center"
                },
                border: {
                    top: {style: "thin"},
                    left: {style: "thin"},
                    bottom: {style: "thin"},
                    right: {style: "thin"}
                }
            }
        }
        for(let ii = headerRowNum + 1; ii <= headerRowNum + mainData.length; ii++){
            //data
            const row = [
                JSON.stringify(mainData[ii - (headerRowNum + 1)]) !== "{}"?"Construct Smarter":"",
                mainData[ii - (headerRowNum + 1)].userName,
                mainData[ii - (headerRowNum + 1)].lanId,
                mainData[ii - (headerRowNum + 1)].phoneNumber,
                pos(mainData[ii - (headerRowNum + 1)].outside),
                mainData[ii - (headerRowNum + 1)].residence,
                mainData[ii - (headerRowNum + 1)][week]?.form[0].yard ?? "",
                mainData[ii - (headerRowNum + 1)][week]?
                (mainData[ii - (headerRowNum + 1)][week].form.some(day => day.availablity === "Yes")?"Available":"Not Available")
                :"",
                //...data[0].form.map(day => day.availablity)
            ]
            worksheet.getRow(ii).values = row;
            //style info
            for(let iii = 1; iii <= infoColNum; iii++){
                worksheet.getCell(ii, iii).style = {
                    fill: {
                        type: "pattern", 
                        pattern:"solid", 
                        fgColor:{argb: ii % 2?"DEEAF6":"9CC2E5"}
                    }, 
                    alignment: {
                        vertical: "middle", 
                        horizontal: "center"
                    },
                    border: {
                        top: {style: "thin"},
                        left: {style: "thin"},
                        bottom: {style: "thin"},
                        right: {style: "thin"}
                    }
                }
            }
            //data validataion
            worksheet.getCell(ii, availabilityColNum).dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: [`"Available,Not Available"`]
            };
            //style data
            for(let iii = infoColNum + 1; iii <= totalColNum; iii++){
                worksheet.getCell(ii, iii).style = {
                    fill: {
                        type: "pattern", 
                        pattern:"solid", 
                        fgColor:{argb: mainData[ii - (headerRowNum + 1)][week]?(mainData[ii - (headerRowNum + 1)][week].form[iii - (infoColNum + 1)].availablity === "Yes"?"00B050":"FF0000") : (ii % 2?"DEEAF6":"9CC2E5")}
                    },
                    alignment: {
                        vertical: "middle", 
                        horizontal: "center"
                    },
                    border: {
                        top: {style: "thin"},
                        left: {style: "thin"},
                        bottom: {style: "thin"},
                        right: {style: "thin"}
                    }
                }
            }
        }

        worksheet.autoFilter = {
            from: {
                row: 2,
                column: 5
            },
            to: {
                row: 1 + mainData.length,
                column: 5
            }
            }

        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 ----------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });

        //generate Excel
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `EOT ${getDatefromWeekNum(week, 4).slice(5)} to ${getDatefromWeekNum(week, 10).slice(5)}.xlsx`);
            setShowLoader(false);
        })
    }
    //--------------------------------------------------------------------------------------------
    return(
        <button type = "button" className = "btn btn-primary" onClick = {() => handleExport()}>Export</button>
    )
}
